import { Component, OnInit, ElementRef, ViewChild, ViewContainerRef } from "@angular/core";
import { DatePipe } from "@angular/common";
import {
  FormGroup,
  FormBuilder,
  FormControl,
  FormArray,
  Validators
} from "@angular/forms";
import { DataSourceRequestState, groupBy } from "@progress/kendo-data-query";
import {
  GridDataResult,
  DataStateChangeEvent
} from "@progress/kendo-angular-grid";
import { ISubscription } from "rxjs/Subscription";
import { ActionName } from "@shared/enums/action-name";
import { AuthService } from "@services/auth.service";
import { CommonMethods } from "@services/common.method";
import { CommonService } from "@shared/services/common";
import { CustomerService } from '@fs/services/customer';
import { DataService } from "@shared/services/kendo-grid-data";
import { FsLiteCustomerCreateComponent } from "@fs/components/customer/cust-create/cust-create.component";
import { PermissionPipe } from "@shared/pipes/permission";
import { TabOpenService } from "@services/tab-open.service";
import { Tabs } from "@enums/tab.enum";
import { TimeZoneConverter } from "@shared/pipes/timezone-converter";
import { UserModel } from "@fs/models/customer/billing-detail.model";
import {
  UserAppointment,
  WorkOrderModel,
  WorkTicketTechnician
} from "src/app/fs-lte/models/work-order/work-order.model";
import { WorkOrderService } from "@fs/services/work-order";
import { NotificationsService } from "@shared/services/notification";
import { Constants } from "@shared/models/constants";
import { CodeTypes } from "src/app/fs-lte/enums/code-types.enum";
import { SpinnerService } from "src/app/shared/services/spinner.service";
import { Grid } from "@fs/enums/grid.enum";
import { FsUtil } from "@fs/services/fs-utils";
import { DataSharingLTE } from "@fs/services/data-sharing-lte.service";

@Component({
  selector: "app-work-order-create",
  templateUrl: "./wo-create.component.html",
  styleUrls: ["./wo-create.component.scss"],
  providers: [
    DataService,
    CustomerService,
    WorkOrderService,
    TimeZoneConverter,
    DatePipe
  ]
})
export class WorkOrderCreateComponent implements OnInit {
  // #region  ViewChild References
  @ViewChild("ElAdvancedSearchOption") ElAdvancedSearchOption: any;
  @ViewChild("ElAdvancedSearch") ElAdvancedSearch: ElementRef;
  @ViewChild("CustomerCreate") CustmCreateComp: FsLiteCustomerCreateComponent;
  @ViewChild("newWorkOrderModal") newWorkOrderModal: ElementRef;
  @ViewChild("Comment") CommentDiv: ElementRef;
  @ViewChild("customerJobSite") customerJobSiteDiv: ElementRef;
  @ViewChild("WorkOrderInfo") WorkOrderInfoDiv: ElementRef;
  @ViewChild("technician") technicianDiv: ElementRef;
  @ViewChild("helper") helperDiv: ElementRef;
  @ViewChild("customerdetail", {
    read: ViewContainerRef
  }) customerdetail: ViewContainerRef;
  @ViewChild("createworkorderform", {
    read: ViewContainerRef
  }) createworkorderform: ViewContainerRef;
  
  // #endregion

  // #region  Private Variables
  private listGetSubscription: ISubscription;
  private listGetSubscription_fetchCustomer: ISubscription;
  private listGetSubscription_DataStateChange: ISubscription;
  private listGetSubscription_fetchCustomer_DataStateChange: ISubscription;
  private listGetSubscription_SelectedRowChange: ISubscription;
  private minDate = new Date();
  private goToCustomerSearch: boolean = false;
  private subscriptions: ISubscription[] = [];
  // #endregion

  // #region  Public Variables
  public isUnsavedTriggered: boolean = false;
  public customFilterForm: FormGroup;
  public ActionName = ActionName;
  public CommentDivValid: boolean = true;
  public SelectedFieldsValues = [];
  public WorkOrderInfoDivValid: boolean = true;
  public advancedFilterFields = [];
  public cancelConfirmation: boolean = false;
  public changeViewConfirmation: boolean = false;
  public createWorkTicketForm: FormGroup;
  public customerId: string;
  public customerRecords: GridDataResult = { data: [], total: 0 };
  public customerSelectedForTicket = false;
  public initialData: any;
  public inputParams: any;
  public isFirstTechRowCreated: boolean = false;
  public isFirstTechSelected: boolean = false;
  public jobsiteId: string;
  public methodUrl: string = "JobSite";
  public selectedCustomerDetail: any;
  public selectedData: any = {};
  public showCustomerDetail: boolean = false;
  public showNewCustomer: boolean = false;
  public state: DataSourceRequestState = { skip: 0, take: 8 };
  public tabCounter: number;
  public technicianDivValid: boolean = true;
  public technicians: any = [];
  public techniciansData: Array<{ name: string, id: string, department: string }> = [];
  public techGroupedData: any[] = [];
  public helperGroupedData: any[] = [];
  public helperGroupedDataRow: any[] = [];
  public times = [];
  public workOrderInfoFilled = false;
  public techName: string = "";
  public hasWorkOrderEditPermission: boolean = true;

  /* Kendo TimePicker */
  public steps: any = { hour: 1, minute: 30, second: 30 };
  public value: Date = new Date(2000, 1, 1, 10, 30);
  public format = "hh:mm a";
  /* Kendo TimePicker End */
  // #endregion

  // #region  LifeCycleEvents
  constructor(
    private _elementRef: ElementRef,
    private auth: AuthService,
    private commonMethods: CommonMethods,
    private customerService: CustomerService,
    private dataService: DataService,
    private frmbuilder: FormBuilder,
    private httpCommon: CommonService,
    private permissionPipe: PermissionPipe,
    private tabOpen: TabOpenService,
    private toastr: NotificationsService,
    private workOrderService: WorkOrderService,
    public datePipe: DatePipe,
    private showspinner: SpinnerService,
    private viewContainerRef: ViewContainerRef,
    private dataShareEmitter: DataSharingLTE
  ) {
    this.minDate.setHours(0, 0, 0, 0);
    let subscription = this.tabOpen.ChangeComponentEvent.subscribe(response => {
      if (response.removeSubscriptions != undefined) {
        if (response.removeSubscriptions) {
          this.DestroySubscriptions();
        }
      }
    })
    this.subscriptions.push(subscription);
  }
  ngOnDestroy() {
    this.DestroySubscriptions();
  }

  private DestroySubscriptions() {
    this.subscriptions.forEach(element => {
      element.unsubscribe();
    });
    if (this.listGetSubscription != null && this.listGetSubscription != undefined) {
      this.listGetSubscription.unsubscribe();
    }
    if (this.listGetSubscription_fetchCustomer != null && this.listGetSubscription_fetchCustomer != undefined) {
      this.listGetSubscription_fetchCustomer.unsubscribe();
    }
    if (this.listGetSubscription_DataStateChange != null && this.listGetSubscription_DataStateChange != undefined) {
      this.listGetSubscription_DataStateChange.unsubscribe();
    }
    if (this.listGetSubscription_fetchCustomer_DataStateChange != null
      && this.listGetSubscription_fetchCustomer_DataStateChange != undefined) {
      this.listGetSubscription_fetchCustomer_DataStateChange.unsubscribe();
    }
    if (this.listGetSubscription_SelectedRowChange != null
      && this.listGetSubscription_SelectedRowChange != undefined) {
      this.listGetSubscription_SelectedRowChange.unsubscribe();
    }
  }

  ngOnInit() {
    this.IntializeForm();
    let subscription = this.httpCommon
      .GetIntialData(
        this.auth.getCompanyId(),
        "PromisedTimes,ServiceTypes,Departments,workticketprioritylookup"
      )
      .subscribe(response => {
        this.initialData = response;
        if (!CommonMethods.CheckNullOrUndefined(this.inputParams.DepartmentID)) {
          this.createWorkTicketForm.controls["Department"].setValue(this.inputParams.DepartmentID);
          this.DepartmentChanged(this.inputParams.DepartmentID);
        }
        if (!CommonMethods.CheckNullOrUndefined(this.inputParams.ServiceTypeId))
          this.createWorkTicketForm.controls["ServiceType"].setValue(this.inputParams.ServiceTypeId);
      });
    this.subscriptions.push(subscription);
    subscription = this.httpCommon.GetTechnicianData(this.auth.getCompanyId(), 'Department').subscribe(
      response => {
        if (response != null) {
          this.technicians = response;
          this.setKendoTechData(this.technicians);
          this.setKendoHelperData(this.technicians);
        }
        if (!CommonMethods.CheckNullOrUndefined(this.inputParams.TechID)) {
          this.createWorkTicketForm.controls["User"].setValue(this.inputParams.TechID);
          this.TechChanged(this.inputParams.TechID, 0);
        }
      });
    this.subscriptions.push(subscription);
    FsUtil.configFilters(this.advancedFilterFields, Grid.NewWorkOrder);
    this.IntializeFilters();
    subscription = this.tabOpen.ConfirmDestroyTabEvent.subscribe(response => {
      if (response.tabCounter == this.tabCounter) {
        this.CreateAndCloseWorkOrder();
      }
    });
    this.subscriptions.push(subscription);
    this.IncrementTime();
    if (this.inputParams.data != undefined) {
      this.SetWorkOrderJobsiteDetails(this.inputParams.data);
    }
    this.hasWorkOrderEditPermission = this.permissionPipe.transform(ActionName.EditWorkOrder);
    this.PrefillData(this.inputParams);

    // initialize helper form
    this.IntializeHelperFormArray();
  }

  ngDoCheck() {
    this.workOrderInfoFilled =
      this.WorkOrderInfoDiv.nativeElement.getElementsByClassName("ng-invalid")
        .length == 0;

    if (!this.isUnsavedTriggered) {
      let isDirty = this.createWorkTicketForm.dirty;
      if (isDirty) {
        this.isUnsavedTriggered = true;
        this.tabOpen.unsavedChangedDetected({
          dirty: isDirty,
          Index: this.tabCounter
        });
      }
    }
  }
  // #endregion

  // #region  Private Methods
  private OnSubmitError() {
    if (this.commonMethods.checkValidity(this.CommentDiv.nativeElement))
      this.commonMethods.toggleBoxes(this.CommentDiv.nativeElement, [
        this.WorkOrderInfoDiv.nativeElement,
        this.technicianDiv.nativeElement,
        this.customerJobSiteDiv.nativeElement
      ]);
    else if (
      this.commonMethods.checkValidity(this.WorkOrderInfoDiv.nativeElement)
    )
      this.ToggleBoxCustom(this.WorkOrderInfoDiv.nativeElement, [
        this.CommentDiv.nativeElement,
        this.technicianDiv.nativeElement,
        this.customerJobSiteDiv.nativeElement
      ]);
    else if (this.commonMethods.checkValidity(this.technicianDiv.nativeElement))
      this.commonMethods.toggleBoxes(this.technicianDiv.nativeElement, [
        this.CommentDiv.nativeElement,
        this.WorkOrderInfoDiv.nativeElement,
        this.customerJobSiteDiv.nativeElement
      ]);
  }
  private CheckAllDivValidity() {
    this.CommentDivValid = !this.commonMethods.checkValidity(
      this.CommentDiv.nativeElement
    );
    this.technicianDivValid = !this.commonMethods.checkValidity(
      this.technicianDiv.nativeElement
    );
    this.WorkOrderInfoDivValid = !this.commonMethods.checkValidity(
      this.WorkOrderInfoDiv.nativeElement
    );
  }
  private IntializeFilters() {
    this.customFilterForm = this.frmbuilder.group({
      searchFilters: this.frmbuilder.array([]),
      searchString: new FormControl("")
    });
  }
  private IncrementTime() {
    var x = 15; //minutes interval
    var starttime = 0;
    var ampm = ["AM", "PM"];

    for (var i = 0; starttime < 24 * 60; i++) {
      var hrs = Math.floor(starttime / 60);
      var mins = starttime % 60;
      this.times[i] =
        ("0" + (hrs % 12)).slice(-2) +
        ":" +
        ("0" + mins).slice(-2) +
        " " +
        ampm[Math.floor(hrs / 12)];
      starttime = starttime + x;
    }
  }
  private CreateModel(showHelperToast: boolean = false) {
    let createticketForm = Object.assign({}, this.createWorkTicketForm.value);
    let model = new WorkOrderModel();
    let ownerUserModel = new UserModel();
    model.JobSite = Object.assign({ ID: this.jobsiteId });
    model.Customer = Object.assign({ ID: this.customerId });
    model.ServiceType =
      createticketForm.ServiceType != ""
        ? Object.assign({ ID: createticketForm.ServiceType })
        : null;
    model.Department =
      createticketForm.Department != ""
        ? Object.assign({ ID: createticketForm.Department })
        : null;
    model.PromisedTime = Object.assign({ ID: createticketForm.PromisedTime });
    model.RequestedBy = createticketForm.RequestedBy;
    model.PromisedDate = this.datePipe.transform(
      createticketForm.PromisedDate,
      "MM/dd/yyyy"
    );
    model.Priority =
      createticketForm.Priority != ""
        ? Object.assign({ ID: createticketForm.Priority })
        : null;
    model.DispatchComment = createticketForm.DispatchComment;
    model.CustomerPO = createticketForm.CustomerPO;
    model.AssignedTechnicians = [];

    let appointmentTypes = this.commonMethods.getCodeTypeData(CodeTypes.AppointmentType);
    let appointments = [];

    //primary tech
    if (createticketForm.ScheduleType == "1") {
      let techObj = new UserAppointment();
      techObj.ID = CommonMethods.GetID();
      techObj.UserID = createticketForm.User;
      ownerUserModel.ID = techObj.UserID;

      techObj.AppointmentDate = this.datePipe.transform(
        new Date(
          createticketForm.PromisedDate.toDateString("MM/dd/yyyy")
        ),
        "MM/dd/yyyy"
      );;

      let TechnicianCodeTypeID: string = appointmentTypes.find(x => x.Code == 'PrimaryTech').ID;
      techObj.AppointmentTypeID = TechnicianCodeTypeID;

      let objStartTime = createticketForm.StartTime;
      techObj.StartTime = new Date(
        createticketForm.PromisedDate.toDateString("MM/dd/yyyy") +
        " " +
        objStartTime.getHours() + ":" + objStartTime.getMinutes() + ":" + objStartTime.getSeconds()
      )
        .toTimeString()
        .split(" ")[0];

      let objEndTime = new Date(objStartTime);
      let duration = parseInt(createticketForm.DurationHour) * 60 + parseInt(createticketForm.DurationMin);
      objEndTime.setMinutes(objStartTime.getMinutes() + duration);
      techObj.EndTime = new Date(
        createticketForm.PromisedDate.toDateString("MM/dd/yyyy") +
        " " +
        objEndTime.getHours() + ":" + objEndTime.getMinutes() + ":" + objEndTime.getSeconds()
      )
        .toTimeString()
        .split(" ")[0];

      techObj.ModifyDate = (new Date()).toDateString();
      appointments.push(techObj);
    } else {
      let objStartTime = new Date();
      objStartTime.setMinutes(0);
      objStartTime.setHours(0);
      objStartTime.setSeconds(0);
      let objEndTime = new Date(objStartTime);
      let duration = parseInt(createticketForm.DurationHour) * 60 + parseInt(createticketForm.DurationMin);
      objEndTime.setMinutes(objStartTime.getMinutes() + duration);
      model.Duration = new Date(
        createticketForm.PromisedDate.toDateString("MM/dd/yyyy") +
        " " +
        objEndTime.getHours() + ":" + objEndTime.getMinutes() + ":" + objEndTime.getSeconds()
      )
        .toTimeString()
        .split(" ")[0];
      ownerUserModel.ID = "";
    }

    //helpers
    this.HelpersForm.controls.forEach((helper: FormGroup) => {
      if (helper.get('HelperId').value != '') {
        let helperObj = new UserAppointment();
        helperObj.ID = CommonMethods.GetID();
        helperObj.Note = helper.get('Note').value;
        helperObj.UserID = helper.get('HelperId').value;
        helperObj.AppointmentDate = this.datePipe.transform(new Date(helper.get('Date').value), "MM/dd/yyyy");

        let helperCodeTypeID: string = appointmentTypes.find(x => x.Code == 'Helper').ID;
        helperObj.AppointmentTypeID = helperCodeTypeID;

        let objStartTime = helper.get('StartTime').value
        helperObj.StartTime = new Date(
          createticketForm.PromisedDate.toDateString("MM/dd/yyyy") +
          " " +
          objStartTime.getHours() + ":" + objStartTime.getMinutes() + ":" + objStartTime.getSeconds()
        )
          .toTimeString()
          .split(" ")[0];

        let objEndTime = new Date(objStartTime);
        let duration = parseInt(helper.get('DurationHour').value) * 60 + parseInt(helper.get('DurationMin').value);
        objEndTime.setMinutes(objStartTime.getMinutes() + duration);
        helperObj.EndTime = new Date(
          createticketForm.PromisedDate.toDateString("MM/dd/yyyy") +
          " " +
          objEndTime.getHours() + ":" + objEndTime.getMinutes() + ":" + objEndTime.getSeconds()
        )
          .toTimeString()
          .split(" ")[0];
        helperObj.ModifyDate = (new Date()).toDateString();
        helperObj.IsSchedule = helper.get('autoschedule').value;
        if (!showHelperToast && helperObj.IsSchedule)
          showHelperToast = true;
        appointments.push(helperObj);
      }
    });

    model.UserAppointments = appointments;
    model.OwnerUser = ownerUserModel.ID != "" ? ownerUserModel : null;
    model.Status = null;
    model.SubStatus = null;
    model.VisitID = this.inputParams.VisitId;

    return model;
  }

  private IntializeForm() {
    this.createWorkTicketForm = this.frmbuilder.group({
      ID: new FormControl(null),
      DispatchComment: new FormControl("", [
        Validators.required,
        this.commonMethods.noWhitespaceValidator,
        Validators.maxLength(1024)
      ]),
      JobSite: new FormControl(null),
      Customer: new FormControl(null),
      ServiceType: new FormControl("", Validators.required),
      Department: new FormControl("", Validators.required),
      PromisedTime: new FormControl("", Validators.required),
      OwnerUser: new FormControl(null),
      Priority: new FormControl("", Validators.required),
      RequestedBy: new FormControl(),
      PromisedDate: new FormControl(null, Validators.required),
      CustomerPO: new FormControl("Dummy Text"),
      WorkTicketPriceBookItems: new FormControl([]),
      WorkTicketDiscountItems: new FormControl([]),
      WorkTicketPayment: new FormControl(null),
      ScheduleType: new FormControl("2"),
      StartTime: new FormControl(""),
      DurationHour: new FormControl("1", Validators.required),
      DurationMin: new FormControl("00", Validators.required),
      User: new FormControl("")
    });
    
    let subscription = this.createWorkTicketForm.controls[
      "ServiceType"
    ].valueChanges.subscribe(value => {
      let service = this.initialData.ServiceTypes.find(x => x.ID == value);
      this.selectedData.ServiceType = service == undefined ? "" : service.Name;
    });
    this.subscriptions.push(subscription);
    subscription = this.createWorkTicketForm.controls[
      "PromisedTime"
    ].valueChanges.subscribe(value => {
      let promisedTime = this.initialData.PromisedTimes.find(
        x => x.ID == value
      );
      this.selectedData.PromisedTime =
        promisedTime == undefined ? "" : promisedTime.Name;
    });
    this.subscriptions.push(subscription);
    subscription = this.createWorkTicketForm.controls[
      "DispatchComment"
    ].valueChanges.subscribe(value => {
      this.selectedData.DispatchComment = value;
    });
    this.subscriptions.push(subscription);
    subscription = this.createWorkTicketForm.controls["ScheduleType"].valueChanges.subscribe(value => {
      if (value == 1) {
        this.createWorkTicketForm.controls["StartTime"].setValidators([Validators.required]);
        this.createWorkTicketForm.controls["User"].setValidators([Validators.required]);
      } else {
        this.createWorkTicketForm.controls["StartTime"].setValidators(null);
        this.createWorkTicketForm.controls["User"].setValidators(null);
      }
      this.createWorkTicketForm.controls["StartTime"].updateValueAndValidity();
      this.createWorkTicketForm.controls["User"].updateValueAndValidity();
    });
    this.subscriptions.push(subscription);
  }
  private Pad(num, size) {
    return Constants.Pad(num, size);
  }
  private OptionalValidation(control: FormControl): any {
    if (control != undefined && control.parent != undefined) {
      if (control.parent.controls["User"].value != "") {
        if (control.value == "" || control.value == null) {
          return { required: true };
        }
      }
    }
    return null;
  }
  private TimeValidation(control: FormControl): any {
    if (
      control != undefined &&
      control.parent != undefined &&
      control.parent.controls["StartTime"].value != "" &&
      control.parent.controls["EndTime"].value != ""
    ) {
      let objStartTime = control.parent.controls["StartTime"].value
      let objEndTime = control.parent.controls["EndTime"].value
      if (objStartTime == null && objEndTime == null) {
        return null;
      }
      else if (objStartTime >= objEndTime) {
        return { InvalidTime: true };
      }
    }
    return null;
  }
  private ToggleBoxCustom(showElement, hideElementList) {
    if ($(showElement).hasClass("hidden")) {
      $(showElement).toggleClass("hidden");
      $(showElement)
        .find(".collapse__box__body")
        .slideToggle();
    }
    hideElementList.forEach(element => {
      if (!$(element).hasClass("hidden")) {
        $(element).toggleClass("hidden");
        $(element)
          .find(".collapse__box__body")
          .slideToggle();
      }
    });
    $(showElement)
      .find(
        ".form-control.ng-invalid:not(.k-datepicker),.form-control.ng-invalid.k-datepicker input"
      )
      .first()
      .focus();
  }

  /**
   * Prefill in case new work order is opened from dispatcher
   * @param params
   */
  private PrefillData(params) {
    if (!CommonMethods.CheckNullOrUndefined(params, true)) {
      if (!CommonMethods.CheckNullOrUndefined(params.ScheduleType))
        this.createWorkTicketForm.controls["ScheduleType"].setValue(params.ScheduleType.toString());

      if (!CommonMethods.CheckNullOrUndefined(params.PromisedDate))
        this.createWorkTicketForm.controls["PromisedDate"].setValue(params.PromisedDate);
      
      if (!CommonMethods.CheckNullOrUndefined(params.StartTime))
        this.createWorkTicketForm.controls["StartTime"].setValue(params.StartTime);
            
      if (!CommonMethods.CheckNullOrUndefined(params.DispatchComment)) 
        this.createWorkTicketForm.controls["DispatchComment"].setValue(params.DispatchComment);
    }
    this.toggle__collapse(this.helperDiv.nativeElement);
  }
  // #endregion

  // #region  Public Methods
  public GetPromiseTimes() {
    return this.initialData != null
      ? this.initialData.PromisedTimes.filter(x => x.IsActive)
      : [];
  }
  public QuickSearch() {
    let searchString = this.customFilterForm.controls["searchString"].value.trim();
    if (searchString.length == 0 || searchString.length > 2) {
      this.SetFilters({ advanceFilterActive: null, applyAdvanceFilter: false });
    }
  }
  public ClearQuickSearch() {
    this.customFilterForm.controls["searchString"].patchValue("");
    this.SetFilters({ applyAdvanceFilter: false, advanceFilterActive: null });
  }
  public SetFilters(
    setFilterBtn: { applyAdvanceFilter: boolean; advanceFilterActive: any } = {
      advanceFilterActive: true,
      applyAdvanceFilter: null
    }
  ) {
    let filterArray = <FormArray>(
      this.customFilterForm.controls["searchFilters"]
    );
    if (setFilterBtn.applyAdvanceFilter) {
      this.state.filter = { logic: "and", filters: filterArray.value };
      if (setFilterBtn.advanceFilterActive) {
        $(this.ElAdvancedSearch.nativeElement).addClass("active");
      } else {
        $(this.ElAdvancedSearch.nativeElement).removeClass("active");
      }
    }
    if (
      this.customFilterForm.controls["searchString"].value == "" &&
      filterArray.length == 1 &&
      filterArray.at(0).get("field").value == ""
    ) {
      if (this.customerRecords != null && this.customerRecords != undefined) {
        this.customerRecords.data = [];
        this.customerRecords.total = 0;
      }
      this.showCustomerDetail = false;
      //this.previewDetailEvent.emit({ customerID: "", show: false })
      return;
    }
    this.showspinner.showloader(this.viewContainerRef, this.tabCounter);
    if (
      this.listGetSubscription != null &&
      this.listGetSubscription != undefined
    ) {
      this.listGetSubscription.unsubscribe();
    }
    this.listGetSubscription = this.customerService
      .getListOfCustomers(
        this.methodUrl,
        this.state,
        this.customFilterForm.controls["searchString"].value
      )
      .subscribe(
        response => {
          if (response != null) {
            if (response.Count > 0) {
              if (
                this.listGetSubscription_fetchCustomer != null &&
                this.listGetSubscription_fetchCustomer != undefined
              ) {
                this.listGetSubscription_fetchCustomer.unsubscribe();
              }
              this.listGetSubscription_fetchCustomer = this.dataService
                .fetchCustomer(response, this.state)
                .subscribe(r => {
                  this.customerRecords = r;
                  this.showCustomerDetail = false;
                  $(this._elementRef.nativeElement)
                    .find(".customer__table__row")
                    .removeClass("active");
                });
              this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
            } else {
              this.showCustomerDetail = false;
              this.customerRecords.data = [];
              this.customerRecords.total = 0;
            }
          }
          this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
        },
        () => {
          this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
        }
      );
  }
  public DataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.showspinner.showloader(this.viewContainerRef, this.tabCounter);
    if (
      this.listGetSubscription_DataStateChange != null &&
      this.listGetSubscription_DataStateChange != undefined
    ) {
      this.listGetSubscription_DataStateChange.unsubscribe();
    }
    this.listGetSubscription_DataStateChange = this.customerService
      .getListOfCustomers(
        this.methodUrl,
        this.state,
        this.customFilterForm.controls["searchString"].value
      )
      .subscribe(response => {
        if (response != null) {
          if (response.Count > 0) {
            if (
              this.listGetSubscription_fetchCustomer_DataStateChange != null &&
              this.listGetSubscription_fetchCustomer_DataStateChange !=
              undefined
            ) {
              this.listGetSubscription_fetchCustomer_DataStateChange.unsubscribe();
            }

            this.listGetSubscription_fetchCustomer_DataStateChange = this.dataService
              .fetchCustomer(response, this.state)
              .subscribe(r => {
                this.customerRecords = r;
                this.showCustomerDetail = false;
                $(".data__row").removeClass("active");
              });
          } else {
            this.customerRecords.data = [];
            this.customerRecords.total = 0;
          }
        }
        this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
      });
  }
  public ToggleAdvanceSearch() {
    this.ElAdvancedSearchOption.DisplayToggle();
    $(this.ElAdvancedSearch.nativeElement).toggleClass("search__hidden");
  }
  public ChangeView(ref) {
    if (ref) {
      this.showNewCustomer = !this.showNewCustomer;
    }
    this.changeViewConfirmation = false;
  }
  public Saveandchangeview() {
    this.changeViewConfirmation = false;
    this.goToCustomerSearch = true;
    this.SaveCustomer(true);
  }
  public ChangeCustomerView() {
    if (!this.permissionPipe.transform(ActionName.CreateCustomer)) return;
    let isValid = false;
    if (this.CustmCreateComp != undefined && !this.CustmCreateComp.newCustomerForm.pristine) {
      this.changeViewConfirmation = true;
      return;
    } else {
      isValid = true;
    }
    if (isValid) {
      this.showNewCustomer = !this.showNewCustomer;
      this.IntializeFilters();
      this.showCustomerDetail = false;
      this.customFilterForm.controls["searchString"].patchValue("");
      if (this.customerRecords != null && this.customerRecords != undefined) {
        this.customerRecords.data = [];
        this.customerRecords.total = 0;
      }
    }
  }
  public ExpandBox(evt, boxRef) {
    let $this = $(evt.target);
    this.CheckAllDivValidity();
    let parent = $this.parents(".content__box__wrapper");
    parent.find(".collapse__box").addClass("hidden");
    $(boxRef).removeClass("hidden");

    parent.find(".collapse__box.hidden .collapse__box__body").slideUp()
    $(boxRef)
      .find(".collapse__box__body")
      .slideDown();
  }
  public SelectedRowChange(ref, data) {
    $(ref.target)
      .parents(".customer__job__site__box")
      .find(".customer__table__row")
      .removeClass("active");
    $(ref.target)
      .parents(".customer__table__row")
      .addClass("active");
    this.showCustomerDetail = true;
    this.showspinner.showloader(this.customerdetail, this.tabCounter);
    if (
      this.listGetSubscription_SelectedRowChange != null &&
      this.listGetSubscription_SelectedRowChange != undefined
    ) {
      this.listGetSubscription_SelectedRowChange.unsubscribe();
    }

    this.listGetSubscription_SelectedRowChange = this.customerService
      .GetJobSiteDetail(data.CustomerID, data.ID, "Customer,Contacts")
      .subscribe(response => {
        this.jobsiteId = data.ID;
        this.customerId = data.CustomerID;
        let billingUnit = response.Customer.Unit != "" && response.Customer.Unit != null ? ", " + response.Customer.Unit : "";
        let jobSiteUnit =
          response.Unit != "" && response.Unit != null
            ? ", " + response.Unit
            : "";
        let jobSiteCity = response.City;
        let jobSiteState = response.State;
        let jobSiteZipCode = response.ZipCode;
        let jobSiteAddress =
          response.StreetNo + "" + jobSiteUnit;
        this.selectedCustomerDetail = {
          JobSiteDisplayName: data.DisplayName,
          JobSiteAddress: jobSiteAddress,
          JobSiteCity: jobSiteCity,
          JobSiteState: jobSiteState,
          JobSiteZipCode: jobSiteZipCode,
          JobSiteContactName:
            response.Contacts[0].Contact.FirstName +
            " " +
            (!CommonMethods.CheckNullOrUndefined(response.Contacts[0].Contact.LastName) ? response.Contacts[0].Contact.LastName : ""),
          BillingDisplayName: response.Customer.DisplayName,
          BillingAddress: response.Customer.StreetNo + "" + billingUnit,
          BillingCity: response.Customer.City,
          BillingState: response.Customer.State,
          BillingZipCode: response.Customer.ZipCode
        };
        this.showspinner.hideLoader(this.customerdetail, this.tabCounter);
      });
  }
  public SetRequestedBy() {
    $("#openNewWorkOrder").css("display", "none");
    this.createWorkTicketForm.markAsDirty();
    if (!CommonMethods.CheckNullOrUndefined(this.selectedCustomerDetail))
      this.createWorkTicketForm.controls["RequestedBy"].setValue(
        this.selectedCustomerDetail.JobSiteContactName
      );

    this.customerSelectedForTicket = true;
  }
  public SaveCustomer(fromTs = false) {
    if (fromTs) {
      this.goToCustomerSearch = true;
    } else {
      this.goToCustomerSearch = false;
    }
    if (this.CustmCreateComp != undefined) {
      // this.showspinner.showloader(this.viewContainerRef, this.tabCounter);
      this.CustmCreateComp.CreateCustomer(true).then(result => {
        // this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
      });
    }
  }
  public SetWorkOrderJobsiteDetails(result) {
    if (!this.goToCustomerSearch) {
      this.jobsiteId = result.JobSites[0].ID;
      this.customerId = result.ID;
      let unit =
        result.JobSites[0].Unit != "" && result.JobSites[0].Unit != null ? ", " + result.JobSites[0].Unit : "";
      let billingUnit = result.Unit != "" && result.Unit != null ? ", " + result.Unit : "";
      this.selectedCustomerDetail = {
        CustomerID: result.BillingID,
        JobSiteDisplayName: result.JobSites[0].DisplayName,
        JobSiteContactName: result.JobSites[0].Contacts != null ?
          result.JobSites[0].Contacts[0].Contact.FirstName +
          " " +
          result.JobSites[0].Contacts[0].Contact.LastName : "",
        JobSiteAddress: result.JobSites[0].StreetNo + "" + unit,
        JobSiteCity: result.JobSites[0].City,
        JobSiteState: result.JobSites[0].State,
        JobSiteZipCode: result.JobSites[0].ZipCode,
        BillingDisplayName: result.DisplayName,
        BillingAddress: result.StreetNo + "" + billingUnit,
        BillingCity: result.City,
        BillingState: result.State,
        BillingZipCode: result.ZipCode
      };
      this.SetRequestedBy();
    } else {
      this.ChangeView(true);
    }
  }
  public toggle__collapse(trg) {
    var parent = $(trg);
    this.CheckAllDivValidity();
    parent.toggleClass("hidden");
    parent.find(".collapse__box__body").slideToggle();
  }
  public CreateAndCloseWorkOrder() {
    if (this.createWorkTicketForm.valid && this.ValidateScheduledTime() && this.IsHelperFormValid()) {
      let showHelperToast = false;
      let model = this.CreateModel(showHelperToast);
      this.showspinner.showloader(this.createworkorderform, this.tabCounter, 0);
      let subscription = this.workOrderService.SaveWorkOrder(model).subscribe(
        response => {
          this.updateVisit(response);
          if (
            $(this._elementRef.nativeElement)
              .find(".tabs__content__box")
              .hasClass("dirty")
          ) {
            $(this._elementRef.nativeElement)
              .find(".tabs__content__box")
              .removeClass("dirty");
          }
          this.showspinner.hideLoader(this.createworkorderform, this.tabCounter);
          this.tabOpen.DestroyTab(this.tabCounter);
          let message = showHelperToast ? "Success Helper Appointment(s) dispatched successfully" : "Work Order " + response.WorkTicketNo + " created";
          this.toastr.success(message, "Success!");
        },
        error => {
          if (!CommonMethods.CheckNullOrUndefined(error.error.Message))
            this.toastr.showMultiLineError(error.error.Message, "Error");
          this.showspinner.hideLoader(this.createworkorderform, this.tabCounter);
        }
      );
      this.subscriptions.push(subscription);
    } else {
      this.commonMethods.markFormGroupTouched(this.createWorkTicketForm);
      this.commonMethods.markFormArrayTouched(this.HelpersForm);
      setTimeout(() => {
        this.CheckAllDivValidity();
        this.OnSubmitError();
      }, 200);
    }
  }
  public CreateAndEditWorkOrder() {
    if (this.createWorkTicketForm.valid && this.ValidateScheduledTime() && this.IsHelperFormValid()) {
      let showHelperToast = false;
      let model = this.CreateModel(showHelperToast);
      this.showspinner.showloader(this.createworkorderform, this.tabCounter, 0);
      let subscription = this.workOrderService.SaveWorkOrder(model).subscribe(
        response => {
          this.updateVisit(response);
          if (
            $(this._elementRef.nativeElement)
              .find(".tabs__content__box")
              .hasClass("dirty")
          ) {
            $(this._elementRef.nativeElement)
              .find(".tabs__content__box")
              .removeClass("dirty");
          }
          this.showspinner.hideLoader(this.createworkorderform, this.tabCounter);
          this.tabOpen.ReplaceTab({
            CurrentTabIndex: this.tabCounter,
            newTabInfo: {
              tabId: Tabs.FsLiteWorkOrderEdit,
              params: {
                ID: response.ID,
                jobsiteId: model.JobSite.ID,
                customerId: model.Customer.ID
              },
              tabTitle:
                response.WorkTicketNo == null ? "" : response.WorkTicketNo
            }
          });
          let message = showHelperToast ? "Success Helper Appointment(s) dispatched successfully" : "Work Order " + response.WorkTicketNo + " created";
          this.toastr.success(message, "Success!");
        },
        error => {
          if (!CommonMethods.CheckNullOrUndefined(error.error.Message))
            this.toastr.showMultiLineError(error.error.Message, "Error");
          this.showspinner.hideLoader(this.createworkorderform, this.tabCounter);
        }
      );
      this.subscriptions.push(subscription);
    } else {
      this.commonMethods.markFormGroupTouched(this.createWorkTicketForm);
      this.commonMethods.markFormArrayTouched(this.HelpersForm);
      setTimeout(() => {
        this.CheckAllDivValidity();
        this.OnSubmitError();
      }, 200);
    }
  }
  public IsHelperFormValid() {
    let isValid = true;
    this.HelpersForm.controls.forEach((x, i) => {
      if (i != 0 && !x.valid)
        isValid = false;
    });

    return isValid;
  }
  public TechChanged(value, index) {
    let tech = this.technicians.filter(x => x.ID == value);
    this.techName = tech.length > 0 ? tech[0].FirstName + " " + tech[0].LastName : "";
  }
  public DepartmentChanged(value) {
    let department = this.initialData.Departments.find(x => x.ID == value);
    this.selectedData.Department = CommonMethods.CheckNullOrUndefined(department)? "" : department.Name;
  }
  public SetTechProgressTracker(): boolean {
    let IsValidTechForm = true;
    if (this.createWorkTicketForm != null) {
      if (this.createWorkTicketForm.get("PromisedDate") != null && this.createWorkTicketForm.get("PromisedDate").hasError('required')) {
        IsValidTechForm = false;
      }
      else if (this.createWorkTicketForm.get("PromisedTime") != null && this.createWorkTicketForm.get("PromisedTime").hasError('required')) {
        IsValidTechForm = false;
      }
      else if (this.createWorkTicketForm.get("User") != null && this.createWorkTicketForm.get("User").hasError('required')) {
        IsValidTechForm = false;
      }
      else if (this.createWorkTicketForm.get("StartTime") != null && this.createWorkTicketForm.get("StartTime").hasError('required')) {
        IsValidTechForm = false;
      }
      else if (this.createWorkTicketForm.get("DurationHour") != null && this.createWorkTicketForm.get("DurationHour").hasError('required')) {
        IsValidTechForm = false;
      }
      else if (this.createWorkTicketForm.get("DurationMin") != null && this.createWorkTicketForm.get("DurationMin").hasError('required')) {
        IsValidTechForm = false;
      }
      else if (this.createWorkTicketForm.get("DurationHour") != null && this.createWorkTicketForm.get("DurationHour").hasError('pattern')) {
        IsValidTechForm = false;
      }
      else if (this.createWorkTicketForm.get("DurationMin") != null && this.createWorkTicketForm.get("DurationMin").hasError('pattern')) {
        IsValidTechForm = false;
      }
    }

    return IsValidTechForm;
  }
  public CancelAction() {
    this.tabOpen.DestroyTab(this.tabCounter);
  }

  public handleTechnicianFilter(value) {
    let filteredList = this.technicians.filter((s) => `${s.FirstName} ${s.LastName}`.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    this.setKendoTechData(filteredList);
  }
  public setKendoTechData(list) {
    this.techniciansData = [];
    let _this = this;
    _this.techniciansData.push({ name: "Select Technician", id: "", department: "" });
    list.forEach(function (item) {
      if (item.Department != null) {
        _this.techniciansData.push({ name: item.FirstName + ' ' + item.LastName, id: item.ID, department: item.Department.Name });
        _this.techGroupedData = groupBy(_this.techniciansData, [{ field: "department" }]);
      }
    });
  }
  public handleHelperFilter(value) {
    let filteredList = this.technicians.filter((s) => `${s.FirstName} ${s.LastName}`.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    this.setKendoHelperData(filteredList);
  }
  public setKendoHelperData(list) {
    let techData = [];
    let _this = this;
    list.forEach(function (item) {
      if (item.Department != null) {
        techData.push({ name: item.FirstName + ' ' + item.LastName, id: item.ID, department: item.Department.Name });
        _this.helperGroupedData = groupBy(techData, [{ field: "department" }]);
        _this.helperGroupedDataRow = groupBy(techData, [{ field: "department" }]);        
      }
    });
  }
  public ValidateScheduledTime(): boolean {
    let createticketForm = Object.assign({}, this.createWorkTicketForm.value);
    let objStartTime: Date;
    let objEndTime: Date;
    if (createticketForm.ScheduleType == "1" && createticketForm.StartTime) {
      objStartTime = createticketForm.StartTime;
      objEndTime = new Date(objStartTime);
    }
    else {
      objStartTime = new Date();
      objStartTime.setMinutes(0);
      objStartTime.setHours(0);
      objStartTime.setSeconds(0);
      objEndTime = new Date(objStartTime);
    }
    let duration = parseInt(createticketForm.DurationHour) * 60 + parseInt(createticketForm.DurationMin);
    objEndTime.setMinutes(objStartTime.getMinutes() + duration);
    let maxEndTime = new Date(objStartTime);
    maxEndTime.setMinutes(59);
    maxEndTime.setHours(23);
    maxEndTime.setSeconds(0);
    if (objEndTime > maxEndTime) {
      this.toastr.error(
        "Work order must be assigned in the same day."
      );
      return false;
    }
    else if (objEndTime <= objStartTime) {
      this.toastr.error(
        "The end time should always be greater than start time for all assigned technicians."
      );
      return false;
    }
    return true;
  }

  //#region Helpers
  public HelpersForm = new FormArray([]);
  private InitializeHelperForm(): FormGroup {
    const HelperFormRow = new FormGroup({
      HelperId: new FormControl('', Validators.required),
      Name: new FormControl(''),
      Date: new FormControl('', Validators.required),
      StartTime: new FormControl('', Validators.required),
      DurationHour: new FormControl('1', Validators.required),
      DurationMin: new FormControl('00', Validators.required),
      AutoDispatch: new FormControl(false),
      Duration: new FormControl(''),
      Note: new FormControl('', Validators.maxLength(1024)),
      Dirty: new FormControl(false),
      IsEditNotAllowed: new FormControl(false),
      IsDeleteNotAllowed: new FormControl(false),
      ViewStartTime: new FormControl(''),
      Status: new FormControl(''),
      autoschedule: new FormControl(false)
    });
    return HelperFormRow;
  }
  private IntializeHelperFormArray() {
    this.HelpersForm.push(this.InitializeHelperForm());
  }
  public UpdateHelpers(helperRow)
  {
    this.HelpersForm.push(helperRow);
  } 
  public RemoveHelper(val) {
    this.HelpersForm.removeAt(this.HelpersForm.value.indexOf(val));
  }
  CloseItemDropDown() {
    this.helperGroupedData = [];
    this.helperGroupedData.push({ name: "Select Technician", id: "", department: "" });
  }
  OpenItemDropDown() {
    this.helperGroupedData = [];
    let filteredList = this.technicians;
    this.setKendoHelperData(filteredList);
  }
  //#endregion
  private updateVisit(val) {
    if (this.inputParams.VisitId) {
      this.dataShareEmitter.emitVisitChange({ 
        ID: this.inputParams.VisitId, 
        Type: "Status",
        Value: {
          WorkTicketID: val.ID, 
          WorkTicketNo: val.WorkTicketNo 
        }
      });
    }
  }
  // #endregion
}
